/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AuthLoginParam model module.
 * @module model/AuthLoginParam
 * @version 1.0
 */
class AuthLoginParam {
    /**
     * Constructs a new <code>AuthLoginParam</code>.
     * @alias module:model/AuthLoginParam
     * @param password {String} 
     * @param username {String} 
     */
    constructor(password, username) { 
        
        AuthLoginParam.initialize(this, password, username);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, password, username) { 
        obj['password'] = password;
        obj['username'] = username;
    }

    /**
     * Constructs a <code>AuthLoginParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AuthLoginParam} obj Optional instance to populate.
     * @return {module:model/AuthLoginParam} The populated <code>AuthLoginParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AuthLoginParam();

            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} password
 */
AuthLoginParam.prototype['password'] = undefined;

/**
 * @member {String} username
 */
AuthLoginParam.prototype['username'] = undefined;






export default AuthLoginParam;

